import { useState } from 'react'

/**
 * A value somebody has to take somewhere else and paste.
 *
 * Read-only and selected on focus, because the whole job is getting it out
 * intact: a value half-selected by a drag is a value pasted half. The pattern
 * existed three times before this and is a component now because the sign-in
 * settings need two more.
 *
 * The type attribute is not decoration. The global stylesheet matches
 * input[type], so a bare input is an unstyled box that widens its row past the
 * viewport on a phone.
 */
export function CopyField({ label, value }: { label: string; value: string }) {
  const [copied, setCopied] = useState(false)
  const id = `copy-${label.replace(/\W+/g, '-').toLowerCase()}`
  return (
    <div className="stack-tight">
      <label htmlFor={id} className="faint">{label}</label>
      <div className="copy-field">
        <input id={id} type="text" readOnly value={value} onFocus={(e) => e.currentTarget.select()} />
        <button
          className="btn btn-secondary btn-small"
          type="button"
          aria-label={`Copy ${label}`}
          onClick={() => {
            void navigator.clipboard.writeText(value)
            setCopied(true)
          }}
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </div>
  )
}
